import { useEffect, useState } from "react";
import { Row, Col, message } from "antd";
import { RenderHtml3 } from "../components/renderhtml";
import { GetAssistList } from "./ajax";
import { BottomIfor } from "./bottom/bottominfo";
import { ButtonforPh } from "./bottom/buttomforph";
import { CloseOutlined } from '@ant-design/icons'
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";
export function AssistantIntroduce(props) {
  let data = props.location.state
  const [down, setDown] = useState(true)
  const [spread, setSpread] = useState(true)
  const [atlist, setAtList] = useState([])
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);
  const reload = async () => {
    let res = await GetAssistList();
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      setAtList(
        res.data.filter((i) => i.status === 1).sort((a, b) => b.sort - a.sort)
      );
    }
  };
  useEffect(() => {
    reload();
  }, []);
  useEffect(() => {
    document.querySelector(".home-content").style.overflow = !spread
      ? "hidden"
      : "";
    document.documentElement.style.overflow = !spread ? "hidden" : "";

    return () => {
      document.querySelector(".home-content").style.overflow = "";
    };
  }, [spread, down]);
  // useEffect(
  //     ()=>{
  //         let scrolly = document.querySelector('.home-content')

  //         if(!spread){
  //            window.addEventListener('touchmove',function(e){
  //                e.preventDefault()
  //            })
  //         }
  //     },[spread]
  // )

  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
  }, []);

  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <Floatingpc show={shows} showWindow={showWindow} text={text} setText={setText} />
        <div className="person-introduce">
          <div className="persongroup-box">
            {down ? (
              ""
            ) : (
              <div style={{ width: 1180, height: "100%", margin: "0 auto" }}>
                <CloseOutlined
                  style={{
                    color: "#fff",
                    fontSize: 20,
                    zIndex: 90,
                    display: "flex",
                    height: "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setDown(true);
                  }}
                />
              </div>
            )}
            <div
              className="moreassist-icon"
              style={
                down ? { visibility: "visible" } : { visibility: "hidden" }
              }
              onClick={() => {
                setDown(false);
              }}
            >
              <div className="moreassist-icon-en">MORE ASSISTANT</div>
              <div className="moreassist-icon-cn">更多助教</div>
              <div className="down-icon"></div>
            </div>
          </div>
          <div
            className="persondown-box"
            style={
              down ? { height: 0, visibility: "hidden" } : { height: "auto" }
            }
          >
            <div className="scrollpart">
              <div className="assistandetail">
                {atlist
                  ? atlist.map((i) => {
                      return (
                        <div
                          className="singleavatorbox"
                          key={i.id}
                          onClick={() => {
                            props.history.push(`/teache/${i.id}`, {
                              atlist,
                              i,
                            });
                            setDown(true);
                          }}
                        >
                          {i.avatar ? (
                            <div className="singleavatorboxup">
                              <img
                                alt=""
                                src={i.avatar}
                                width="100%"
                                height="100%"
                                style={{ objectFit: "cover" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="singleavatorboxup"
                              style={{ backgroundColor: "#efebe9" }}
                            ></div>
                          )}
                          <div className="singleavatorboxname">{i.name}</div>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
            <div className="bottomicon">
              <div
                className="up-icon"
                onClick={() => {
                  setDown(true);
                }}
              ></div>
            </div>
          </div>
          <div className="persongroup-headerimg">
            {data.i.pictrue ? (
              <img
                src={data.i.pictrue}
                alt=""
                width="100%"
                height="100%"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <div className="tocenternone">没有上传图片噢</div>
            )}
            <div className="personavatorbox">
              {data.i.avatar ? (
                <img
                  alt="加载中"
                  src={data.i.avatar}
                  width="100%"
                  height="100%"
                  style={{ objectFit: "cover" }}
                />
              ) : (
                <div
                  style={{
                    backgroundColor: "#efebe9",
                    width: "100%",
                    height: "100%",
                  }}
                ></div>
              )}
            </div>
          </div>
          {!down ? (
            <div
              style={{
                display: "block",
                position: "fixed",
                top: "0px",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                backgroundColor: "rgba(0,0,0,0.7)",
                zIndex: 9,
              }}
              onClick={() => {
                setDown(true);
              }}
            ></div>
          ) : (
            ""
          )}
          <div className="personintroducebg">
            <div className="personintroducecontent">
              <div className="middlepersonintroduce">
                <div className="assistteach">助教</div>
                <div className="assistname">{data.i.name}</div>
                {data.i.tag !== "" ? (
                  <div className="tagindex">
                    {data.i.tag.split(",").map((i) =>
                      i !== "" ? (
                        <div key={i}>
                          <span>{i}</span>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="introducedetail">
                  <RenderHtml3
                    flow={1000}
                    state={{ content: data.i.introduction }}
                  />
                </div>
                <div className="cnworkstitle">助教作品</div>
                <div className="enworkstitle">ASSISTANT WORKS</div>
                <div className="detailworks">
                  {JSON.parse(data.i.works).map((i) => {
                    return (
                      <img
                        alt=""
                        className="imgstyle"
                        key={i}
                        src={i}
                        width="100%"
                        height="100%"
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <Floatingph showmp={showmp} showFloating={showFloating} text={text} setText={setText} />
        {/* onTouchStart={e=>{
                            e.preventDefault()
                            e.stopPropagation()
                            return false
                        }} */}
        <div className="assistintroduce">
          <div
            className="assistnavdropdown"
            style={
              spread
                ? { maxHeight: 0, transition: "all .3s" }
                : { maxHeight: "9rem", transition: "all .6s" }
            }
          >
            <div
              className="assistnavtitle"
              onClick={() => {
                setSpread(false);
              }}
            >
              <div className="assistnavtitleen">MORE ASSISTANT</div>
              <div className="assistnavtitlecn">更多助教</div>
              <div
                className="assistnavtitledown"
                style={
                  spread ? { visibility: "visible" } : { visibility: "hidden" }
                }
              ></div>
            </div>
            <div
              className="dropdowncontent"
              style={
                spread
                  ? { maxHeight: 0, transition: "all .5s" }
                  : { maxHeight: "9rem", transition: "all .7s" }
              }
              onTouchStart={(e) => {
                e.preventDefault();
                e.stopPropagation();
                return false;
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  padding: "0 0.55rem",
                  maxHeight: "6.5rem",
                  overflowY: "scroll",
                }}
              >
                {atlist
                  ? atlist.map((i) => {
                      return (
                        <div
                          className="avatorimgbox"
                          key={i.id}
                          onClick={() => {
                            props.history.push(`/teache/${i.id}`, {
                              atlist,
                              i,
                            });
                            setSpread(true);
                          }}
                        >
                          <div className="avatorimg">
                            {i.avatar ? (
                              <img
                                alt="加载中"
                                src={i.avatar}
                                width="100%"
                                height="100%"
                                style={{ objectFit: "cover" }}
                              />
                            ) : (
                              <div
                                style={{
                                  backgroundColor: "#efebe9",
                                  width: "100%",
                                  height: "100%",
                                }}
                              ></div>
                            )}
                          </div>
                          <div className="avatorimgname">{i.name}</div>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
            {!spread && (
              <div
                className="upiconarrow"
                onClick={() => {
                  setSpread(true);
                }}
              ></div>
            )}
          </div>
          <div className="personcoverimg">
            {data.i.pictrue ? (
              <img
                alt="加载中"
                src={data.i.pictrue}
                width="100%"
                height="100%"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <div>没有上传图片</div>
            )}
            {data.i.avatar ? (
              <img
                alt="加载中"
                className="personavatorimg"
                src={data.i.avatar}
                width="100%"
                height="100%"
                style={{ objectFit: "contain", overflow: "hidden" }}
              />
            ) : (
              <div
                className="personavatorimg"
                style={{ backgroundColor: "#efebe9" }}
              ></div>
            )}
          </div>
          {!spread ? (
            <div
              style={{
                display: "block",
                position: "fixed",
                top: "0px",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                backgroundColor: "rgba(0,0,0,0.7)",
              }}
              onClick={() => {
                setSpread(true);
              }}
            ></div>
          ) : (
            ""
          )}
          <div className="personintroducecontentdetail">
            <div className="fixedtitle">助教</div>
            <div className="detailname">{data.i.name}</div>
            {data.i.tag !== "" ? (
              <div className="tagindexstyle">
                {data.i.tag.split(",").map((i) => (
                  <div key={i}>
                    <span>{i}</span>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}
            <div className="introduceandworks">
              <div className="singleintroduce">
                {" "}
                <RenderHtml state={{ content: data.i.introduction }} />
              </div>
              <div className="cntitleassist">助教作品</div>
              <div className="entitleassistant">ASSISTANT WORKS</div>
              <div className="assistantworks">
                {JSON.parse(data.i.works).map((i) => {
                  return (
                    <img
                      alt="加载中"
                      className="imgstylecontent"
                      key={i}
                      src={i}
                      width="100%"
                      height="100%"
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <ButtonforPh />
      </Col>
    </Row>
  );
}

function parseStr(str = "") {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, "")) / 1.7);
    return `font-size:${newValue}`;
  });
}

export const RenderHtml = (props) => {
  let {
    state: { content: __html },
    dom,
  } = props;

  //__html
  return (
    <pre
      id="prevs"
      style={{
        lineHeight: "1.5",
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        wordWrap: "break-word",
        overflow: "hidden",
        fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
      }}
    >
      <div
        className="braft-output-content"
        ref={dom}
        dangerouslySetInnerHTML={{ __html: parseStr(__html) }}
      ></div>
    </pre>
  );
};
